<template>
    <div class="h5-input-container flex-row flex-center" :class="{ focus: inputFocused }">
        <div class="h5-input__prepend">
            <div class="to-center w-h-100">
                <slot name="prepend"></slot>
            </div>
        </div>
        <div class="h5-input__body flex-1">
            <input
                class="h5-input__inner"
                :type="type"
                :value="value"
                :disabled="disabled"
                :placeholder="placeholder"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInput"
            />
        </div>
        <div class="h5-input__append flex-row flex-center">
            <slot name="append"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'h5-input',
    model: {
        prop: 'value',
        event: '_input',
    },
    props: {
        value: {
            default: '',
        },
        type: {
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inputFocused: false,
        }
    },
    methods: {
        handleInput(e) {
            this.$emit('_input', e.target.value)
            this.$emit('input', e)
        },
        handleFocus() {
            this.inputFocused = true
            this.$emit('focus')
        },
        handleBlur() {
            this.inputFocused = false
            this.$emit('blur')
        },
    },
}
</script>

<style lang="scss" scoped>
    .h5-input-container {
        height: 32px;
        padding: 2px 6px;
        box-sizing: border-box;
        position: relative;
        background-color: $white;
        border-radius: 15px;
        border: 1px solid var(--theme-color);
        box-shadow: 0 0 4px 2px transparent;
        transition: border-color .25s ease-in-out,
        box-shadow .25s ease-in-out;
        width: 100%;

        // &.focus {
        //     border-color: rgba($themeColor, .5);
        //     box-shadow: 0 0 0 2px rgba($themeColor, .25);
        // }
    }

    .h5-input__body, .h5-input__prepend, .h5-input__append {
        height: 100%;

        .fa {
            padding: 4px 8px;
            width: 30px;
            box-sizing: border-box;
            text-align: center;
            color: var(--theme-color);
        }

        &:empty {
            display: none;
        }
    }

    .h5-input__inner {
        border: none;
        outline: none;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding: 0 4px;
    }
</style>
